// Mobile height START
const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();
// Mobile height END

document.addEventListener('DOMContentLoaded', () => {
    "use strict";


const inputTypeClasses = {
    text: "input-text-wrapper",
    search: "search-wrap",
    password: "input-password-wrapper",
    number: "input-number-wrapper",
    date: "input-date-wrapper",
    file: "input-file-wrapper", // <-- додано для file
    textarea: "textarea-wrapper", // Клас для textarea
    month: "input-date-wrapper"
    // Додайте інші типи за необхідності
};

// Функція для створення обгортки для інпутів і textarea
function wrapInput(input) {
    // Пропускаємо hidden інпути
    if (input.type === 'hidden') {
        return null;
    }
    
    const tagName = input.tagName.toLowerCase(); // Визначаємо тег (input чи textarea)
    const type = input.type; // Для input беремо type

    const wrapper = document.createElement('div');
    wrapper.className = 'input-mask-wrap';

    // Додаємо додатковий клас залежно від типу або тега
    if (tagName === 'textarea') {
        wrapper.classList.add(inputTypeClasses.textarea); // Для textarea
    } else if (inputTypeClasses[type]) {
        wrapper.classList.add(inputTypeClasses[type]); // Для input
    }

    // Переносимо елемент в обгортку
    input.parentElement.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    // Додаємо placeholder-mask, якщо є placeholder (крім file)
    const placeholder = input.getAttribute('placeholder');
    if (placeholder && type !== "file") {
        const span = document.createElement('span');
        span.className = 'placeholder-mask';
        span.textContent = placeholder;
        wrapper.appendChild(span);
    }

    // ===========================================================================
    function updateStatus() {
        const focusState = document.activeElement === input ? 'focus' : 'blur';
        const valueState = input.value.trim() === '' ? 'empty' : 'filled';
        wrapper.setAttribute('data-status', `${focusState} ${valueState}`);
    }

    input.addEventListener('focus', updateStatus);
    input.addEventListener('blur', updateStatus);
    input.addEventListener('input', updateStatus);
    input.addEventListener('change', updateStatus);

    // Кросбраузерне вирішення проблеми з автозаповненням
    // Chrome/Edge: використовуємо animationstart для виявлення автозаповнення
    const handleAutofill = () => {
        // Невелика затримка для того, щоб браузер встиг заповнити поле
        setTimeout(updateStatus, 10);
    };

    // Обробка автозаповнення через animationstart (Chrome/Edge)
    input.addEventListener('animationstart', function(e) {
        if (e.animationName === 'onAutoFillStart' || e.animationName === 'onAutoFillCancel') {
            handleAutofill();
        }
    });

    // Ініціалізація
    updateStatus();

    // Додаткова перевірка після завантаження сторінки для виявлення автозаповнення
    // (працює для всіх браузерів)
    const scheduleStatusUpdate = () => {
        // Множинні перевірки з різними затримками для надійного виявлення автозаповнення
        setTimeout(updateStatus, 50);
        setTimeout(updateStatus, 100);
        setTimeout(updateStatus, 200);
        setTimeout(updateStatus, 300);
        setTimeout(updateStatus, 500);
        setTimeout(updateStatus, 800);
        setTimeout(updateStatus, 1200);
        setTimeout(updateStatus, 2000);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleStatusUpdate);
    } else {
        scheduleStatusUpdate();
    }

    // Додаткова перевірка після повного завантаження сторінки
    if (document.readyState === 'complete') {
        setTimeout(updateStatus, 100);
        setTimeout(updateStatus, 500);
    } else {
        window.addEventListener('load', () => {
            setTimeout(updateStatus, 100);
            setTimeout(updateStatus, 500);
            setTimeout(updateStatus, 1000);
        });
    }

    return wrapper;
}

// Отримуємо всі форми на сторінці
const forms = document.querySelectorAll('form');

forms.forEach(form => {
    // Обгортання всіх інпутів і textarea (виключаємо hidden)
    const inputsAndTextareas = form.querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=hidden]), textarea');
    inputsAndTextareas.forEach(input => wrapInput(input));

    // Робота з select
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
        const wrapper = wrapInput(select);
        wrapper.classList.add('select-container');

        select.addEventListener('focus', () => {
            wrapper.classList.add('active');
        });

        select.addEventListener('blur', () => {
            setTimeout(() => {
                if (!select.matches(':focus')) {
                    wrapper.classList.remove('active');
                }
            }, 100);
        });

        select.addEventListener('change', () => {
            wrapper.classList.toggle('selected', !!select.value);
        });
    });

    // Робота з input[type="number"]
    const inputNumbers = form.querySelectorAll('input[type="number"]');
    inputNumbers.forEach(inputNumber => {
        const wrapper = inputNumber.parentElement;

        const up = document.createElement('div');
        up.className = 'up';
        up.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0V16M0 8H16" stroke="black"/></svg>';

        const down = document.createElement('div');
        down.className = 'down';
        down.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 8H16" stroke="black"/></svg>';

        wrapper.appendChild(down);
        wrapper.appendChild(up);

        if (inputNumber.value === "") {
            inputNumber.value = 0;
        }

        up.addEventListener('click', function () {
            const step = parseFloat(inputNumber.getAttribute('step')) || 1;
            const max = parseFloat(inputNumber.getAttribute('max')) || Infinity;
            let value = parseFloat(inputNumber.value) || 0;
            value = Math.min(value + step, max);
            inputNumber.value = value;
            inputNumber.dispatchEvent(new Event('input', {bubbles: true}));
        });

        down.addEventListener('click', function () {
            const step = parseFloat(inputNumber.getAttribute('step')) || 1;
            const min = parseFloat(inputNumber.getAttribute('min')) || -Infinity;
            let value = parseFloat(inputNumber.value) || 0;
            value = Math.max(value - step, min);
            inputNumber.value = value;
            inputNumber.dispatchEvent(new Event('input', {bubbles: true}));
        });
    });

    // Робота з input[type="password"]
    const passwordInputs = form.querySelectorAll('input[type="password"]');
    passwordInputs.forEach(input => {
        const wrapper = input.parentElement;

        const toggleButton = document.createElement('div');
        toggleButton.className = 'vis-pass';
        toggleButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8s2.5-4 7-4 7 4 7 4-2.5 4-7 4-7-4-7-4z" stroke="black"/><circle cx="8" cy="8" r="2" stroke="black"/></svg>';

        wrapper.appendChild(toggleButton);

        toggleButton.addEventListener('click', function () {
            if (input.type === 'password') {
                input.type = 'text';
                toggleButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8s2.5-4 7-4 7 4 7 4-2.5 4-7 4-7-4-7-4z" stroke="black"/><path d="M2 2l12 12" stroke="black"/></svg>';
            } else {
                input.type = 'password';
                toggleButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8s2.5-4 7-4 7 4 7 4-2.5 4-7 4-7-4-7-4z" stroke="black"/><circle cx="8" cy="8" r="2" stroke="black"/></svg>';
            }
        });
    });

    // Робота з input[type="file"]
    const fileInputs = form.querySelectorAll('input[type="file"]');
    fileInputs.forEach(fileInput => {
        const wrapper = fileInput.parentElement;

        // про всяк випадок додамо клас-мітку
        wrapper.classList.add('input-file-wrapper');

        // створюємо/знаходимо span.file-name
        let fileLabel = wrapper.querySelector('.file-name');
        if (!fileLabel) {
            fileLabel = document.createElement('span');
            fileLabel.className = 'file-name';
            wrapper.appendChild(fileLabel);
        }

        // початковий текст беремо з placeholder інпута
        const placeholderText = fileInput.getAttribute('placeholder') || '';
        fileLabel.textContent = placeholderText;

        // допоміжна для відображення назви(ів) файлу
        const getFileText = () => {
            const { files } = fileInput;
            if (!files || files.length === 0) return placeholderText;
            if (files.length === 1) return files[0].name;
            return `${files.length} files selected`; // підтримка multiple
            // якщо треба всі назви: return Array.from(files).map(f => f.name).join(', ');
        };

        const updateLabel = () => {
            fileLabel.textContent = getFileText();
        };

        fileInput.addEventListener('change', updateLabel);

        // якщо очищають програмно (value = '')
        fileInput.addEventListener('input', () => {
            if (!fileInput.value) fileLabel.textContent = placeholderText;
        });

        // при скиданні форми повертаємо плейсхолдер
        form.addEventListener('reset', () => {
            setTimeout(() => {
                fileLabel.textContent = placeholderText;
            }, 0);
        });
    });

    // Глобальна перевірка автозаповнення для всіх інпутів після завантаження сторінки
    // Це працює для всіх браузерів (Chrome, Firefox, Safari, Edge)
    const checkAutofill = () => {
        const allInputs = document.querySelectorAll('form input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=reset]):not([type=hidden]), form textarea');
        allInputs.forEach(input => {
            const wrapper = input.closest('.input-mask-wrap');
            if (wrapper) {
                const focusState = document.activeElement === input ? 'focus' : 'blur';
                const valueState = input.value.trim() === '' ? 'empty' : 'filled';
                wrapper.setAttribute('data-status', `${focusState} ${valueState}`);
            }
        });
    };
    
    // Робимо функцію доступною глобально для використання в інших скриптах
    window.checkFormInputsStatus = checkAutofill;

    // Розширена функція для перевірки з множинними таймінгами
    const scheduleAutofillCheck = () => {
        // Множинні перевірки для надійності (автозаповнення може відбуватися з різними затримками)
        setTimeout(checkAutofill, 50);
        setTimeout(checkAutofill, 100);
        setTimeout(checkAutofill, 200);
        setTimeout(checkAutofill, 300);
        setTimeout(checkAutofill, 500);
        setTimeout(checkAutofill, 800);
        setTimeout(checkAutofill, 1200);
        setTimeout(checkAutofill, 2000);
    };

    // Перевірка після завантаження DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleAutofillCheck);
    } else {
        scheduleAutofillCheck();
    }

    // Додаткова перевірка після повного завантаження сторінки
    if (document.readyState === 'complete') {
        setTimeout(checkAutofill, 100);
        setTimeout(checkAutofill, 500);
        setTimeout(checkAutofill, 1000);
    } else {
        window.addEventListener('load', () => {
            setTimeout(checkAutofill, 100);
            setTimeout(checkAutofill, 500);
            setTimeout(checkAutofill, 1000);
            setTimeout(checkAutofill, 2000);
        });
    }

    // Перевірка при відновленні сторінки з кешу (включаючи автозаповнення)
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            setTimeout(checkAutofill, 50);
            setTimeout(checkAutofill, 100);
            setTimeout(checkAutofill, 300);
            setTimeout(checkAutofill, 500);
        }
    });

    // Додаткова перевірка при фокусі на формі (на випадок, якщо автозаповнення спрацювало пізніше)
    forms.forEach(form => {
        form.addEventListener('focusin', (e) => {
            if (e.target.matches('input, textarea')) {
                setTimeout(checkAutofill, 50);
                setTimeout(checkAutofill, 200);
            }
        }, true);
    });

    // Додаткова перевірка через requestAnimationFrame для більш плавної роботи
    const rafCheck = () => {
        requestAnimationFrame(() => {
            checkAutofill();
            // Повторюємо перевірку через кілька кадрів
            setTimeout(() => {
                requestAnimationFrame(checkAutofill);
            }, 100);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(rafCheck, 100);
        });
    } else {
        setTimeout(rafCheck, 100);
    }

});

//===============================================================
// POP-UP WINDOWS LOGICAL
//===============================================================

$(function() {
    // Оголошення змінних
    const $popupCloseBtn = $('.popup__close-btn, #update-event-btn, #save-user-btn'),
        $popupWindow = $('.popup__container__window'),
        $body = $('body');

    let popupName, scrollWidth, lastScrollTop;

    // Оновлення ширини скроллбару при завантаженні та зміні розміру
    function updateScrollWidth() {
        scrollWidth = `${window.innerWidth - document.documentElement.clientWidth}px`;
    }
    $(window).on('load resize', updateScrollWidth);

    // Делегування події click на елементи .popup__open-btn в межах .page-content
    // Прибрано .edit-customer та .delete-user, оскільки вони обробляються в специфічних файлах
    $(document).on('click', '.popup__open-btn, ' +
        '.edit-user, ' +
        '.edit-event', function (e) {
        e.preventDefault();  // Блокуємо стандартну поведінку
        popupName = $(this).is('a') ? $(this).attr('href').replace('#', '') : $(this).val();
        
        // Перевіряємо чи є popupName перед відкриттям
        if (!popupName || popupName === '') {
            return;
        }
        
        toggleScrollLock(true);  // Блокуємо прокрутку
        openPopup($(`#${popupName}`));  // Відкриваємо попап
    });

    // Функція для перевірки стану інпутів всередині popup
    function checkPopupInputsStatus($popup) {
        const popupElement = $popup[0] || $popup;
        const allInputs = popupElement.querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=reset]):not([type=hidden]), textarea');
        
        allInputs.forEach(input => {
            const wrapper = input.closest('.input-mask-wrap');
            if (wrapper) {
                const focusState = document.activeElement === input ? 'focus' : 'blur';
                const valueState = input.value.trim() === '' ? 'empty' : 'filled';
                wrapper.setAttribute('data-status', `${focusState} ${valueState}`);
            }
        });
    }

    // Функція відкриття попапу
    function openPopup($popup) {
        closePopup();  // Закриваємо будь-який відкритий попап
        $popup.addClass('popup__open');
        
        // Перевіряємо стан інпутів при відкритті popup
        // Використовуємо невелику затримку, щоб DOM встиг оновитися
        setTimeout(() => {
            // Перевіряємо інпути всередині popup
            checkPopupInputsStatus($popup);
            
            // Також викликаємо глобальну функцію, якщо вона доступна
            if (typeof window.checkFormInputsStatus === 'function') {
                window.checkFormInputsStatus();
            }
            
            // Додаткова перевірка через невеликі інтервали для надійності (на випадок автозаповнення)
            setTimeout(() => {
                checkPopupInputsStatus($popup);
                if (typeof window.checkFormInputsStatus === 'function') {
                    window.checkFormInputsStatus();
                }
            }, 100);
            
            setTimeout(() => {
                checkPopupInputsStatus($popup);
                if (typeof window.checkFormInputsStatus === 'function') {
                    window.checkFormInputsStatus();
                }
            }, 300);
        }, 50);
    }

    // Закриття попапу
    function closePopup() {
        $('.popup__open').removeClass('popup__open');
    }

    // Закриття попапу за допомогою кнопки .popup__close-btn
    // Виключаємо .delete-customer та інші кнопки, які не повинні закривати popup
    $(document).on('mouseup', '.popup__close-btn:not(.delete-customer):not(.delete-user), #update-event-btn, #save-user-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleScrollLock(false);
        closePopup();
    });

    // Закриття попапу при натисканні поза вікном попапу
    $(document).on('mousedown', function (e) {
        if ($('.popup__open').length && !$popupWindow.is(e.target) && !$popupWindow.has(e.target).length) {
            toggleScrollLock(false);
            closePopup();
        }
    });

    // Функція для блокування прокрутки
    function toggleScrollLock(lock) {
        lastScrollTop = $(window).scrollTop();
        $body.css('paddingRight', lock ? scrollWidth : '');  // Блокуємо прокрутку з правим відступом для скроллбару
        $('html').css('overflowY', lock ? 'hidden' : 'visible');  // Блокуємо вертикальну прокрутку
        $('header').css('top', lock ? lastScrollTop : 0);  // Зберігаємо позицію скролу
    }
});

// Функціонал для збільшення зображень

// Функція ініціалізації
function initZoomImage() {
    // Перевіряємо чи існує popup, якщо ні - створюємо
    let popup = document.querySelector('.zoom-image-popup');
    
    if (!popup) {
        // Створюємо HTML структуру popup в кінці body
        const popupHTML = `
            <div class="zoom-image-popup">
                <div class="zoom-image-popup__close"></div>
                <div class="zoom-image-popup__container">
                    <img src="" alt="" />
                </div>
            </div>
        `;
        
        document.body.insertAdjacentHTML('beforeend', popupHTML);
        popup = document.querySelector('.zoom-image-popup');
    }

    // Отримуємо посилання на елементи popup
    const closeBtn = popup.querySelector('.zoom-image-popup__close');
    const img = popup.querySelector('.zoom-image-popup__container img');

    // Функція для відкриття popup
    const openPopup = (imageSrc) => {
        img.src = imageSrc;
        popup.classList.add('active');
    };

    // Функція для закриття popup
    const closePopup = () => {
        popup.classList.remove('active');
        // Очищаємо src після закриття (опціонально, для безпеки)
        setTimeout(() => {
            img.src = '';
        }, 300); // Затримка для анімації закриття
    };

    // Використовуємо делегування подій для динамічно доданих кнопок
    document.addEventListener('click', (e) => {
        const zoomButton = e.target.closest('.zoom-image-btn');
        
        if (zoomButton) {
            e.preventDefault();
            e.stopPropagation();
            
            // Отримуємо посилання на зображення з href або data-src атрибута
            const imageSrc = zoomButton.getAttribute('href') || zoomButton.getAttribute('data-src');
            
            if (imageSrc) {
                openPopup(imageSrc);
            }
        }
    });

    // Закриття при кліку на кнопку закриття
    closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closePopup();
    });

    // Закриття при кліку поза вікном popup
    popup.addEventListener('click', (e) => {
        // Перевіряємо чи клік був саме на popup, а не на дочірні елементи
        if (e.target === popup) {
            e.preventDefault();
            closePopup();
        }
    });

    // Додатково: закриття по клавіші Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });
}

// Ініціалізація після завантаження DOM або одразу якщо DOM вже готовий
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoomImage);
} else {
    initZoomImage();
}




});




